import styled from "styled-components";
import {
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
} from "../../../constants/Styles";
import Link from "next/link";

const BoardCard = styled.div`
  width: 100%;
  border-radius: 2rem;
  display: flex;
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%),
    ${COLORS.tableBackground};
  padding: 2rem;
  gap: 2rem;
`;

const BoardPreviewContainer = styled.div`
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
`;

const BoardInfo = styled.div`
  min-width: 0;
  flex: 5;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
`;

const InfoRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const TitleInfoRow = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
`;

const NameLinkAndTools = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const ProjectOwnerRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const DetailsInfoRow = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size13};
  font-weight: ${FONT_WEIGHT.weight500};
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
`;

const ShipmentsRows = styled.div`
  font-size: ${FONT_SIZE.size13};
  font-weight: ${FONT_WEIGHT.weight500};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
`;

const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const BoardNameLink = styled(Link)`
  text-decoration: none;
  color: ${COLORS.secondary};
  font-size: ${FONT_SIZE.size18};
  font-weight: ${FONT_WEIGHT.weight500};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    color: ${COLORS.secondary};
  }
`;

const BoardNickname = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size16};
  font-family: ${FONTS.spaceGrotesk};
  font-weight: ${FONT_WEIGHT.weight500};
`;

const BoardPreview = styled.div`
  > img {
    max-height: 12rem;
    max-width: 100%;
  }
`;

const BoardStatePill = styled.div`
  border-radius: 100px;
  background: ${COLORS.badgeGray};
  padding: 0.25rem 0.75rem 0.25rem 0.5rem;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
  gap: 2px;
  height: 24px;
`;

const ShipmentPill = styled.div`
  color: ${COLORS.secondaryLight};
  border-radius: 1rem;
  background: ${COLORS.inputGray};
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
  white-space: nowrap;
  display: inline-flex;
  align-items: flex-start;
  flex-wrap: wrap;
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
  gap: 0.25rem 1rem;
`;

const ShippingState = styled.div`
  color: ${COLORS.secondary};
`;

export {
  BoardCard,
  BoardPreviewContainer,
  BoardInfo,
  InfoRows,
  ProjectOwnerRow,
  TitleInfoRow,
  DetailsInfoRow,
  ActionsRow,
  BoardNameLink,
  BoardPreview,
  BoardStatePill,
  ShipmentsRows,
  ShipmentPill,
  ShippingState,
  NameLinkAndTools,
  BoardNickname,
};
